import { definePath } from '../../router/definePath';

export const DevicePaths = {
  overview: definePath('authenticated', { de: '/konto/geraete', en: '/account/devices' }),
} as const;
